import Button from '@atlaskit/button/new';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalTransition,
} from '@atlaskit/modal-dialog';
import { Fragment, useCallback, useState } from 'react';

import { createRender } from './types';

export const render = createRender(({ onDismissed, messageInstanceId }) => {
	const [isOpen, setIsOpen] = useState(true);
	const closeModal = useCallback(() => {
		onDismissed(messageInstanceId);
		setIsOpen(false);
	}, [onDismissed, messageInstanceId]);

	return (
		<Fragment>
			<ModalTransition>
				{isOpen && (
					<Modal onClose={closeModal}>
						<ModalHeader>
							<ModalTitle>This is a Post Office Test Message</ModalTitle>
						</ModalHeader>
						<ModalBody>
							<p>This is the modal body</p>
						</ModalBody>
						<ModalFooter>
							<Button appearance="primary" onClick={closeModal}>
								OK
							</Button>
						</ModalFooter>
					</Modal>
				)}
			</ModalTransition>
		</Fragment>
	);
});

export default render;
